
// Missing alot of kendo typings
export default class EditorToolFunctions {
    static openInsertBase64Image(se) {
        const element = $(se.sender.element);
        const editorElement = element.closest(".kendo-text-editor-wrapper").find(".k-editor");
        const editor = editorElement.data("kendoEditor") || editorElement.data("kendoOrphyEditor");
        const action = $(editor.element).data("uploadbase64image");
        const windowWrapper = `<div class='insertBase64ImageWrapper' data-editorid='${editorElement[0].id}'></div>`;
        const window = $(windowWrapper)
            .kendoWindow({
                modal: true,
                resizable: false,
                title: "Upload",
                open(e) {
                    kendo.ui.progress(e.sender.element, true);
                },
                refresh(e) {
                    window.center().open();
                    kendo.ui.progress(e.sender.element, false);
                },
                // remove the Window from the DOM after closing animation is finished
                deactivate(e) { e.sender.destroy(); }
            }).data("kendoWindow");

        window.setOptions({
            width: 480,
            height: 355
        });

        window.refresh({ url: action });
    }

    static changeParagraphToBr() {
        //use <br> instead of <p>
        const defaultTools = (<any>(kendo.ui.Editor)).defaultTools;
        defaultTools["insertLineBreak"].options.shift = false;
        defaultTools["insertParagraph"].options.ctrl = false;
        defaultTools["insertParagraph"].options.shift = true;
    }

    static initializeEditor(kendoEditor: kendo.ui.Editor) {
        const wrapperId = `.${kendoEditor.element[0].id}_wrapper`;

        // 1. Optimized list commands: Isolate current line before listification
        const originalExec = kendoEditor.exec;
        kendoEditor.exec = function (command: string, options: any) {
            const range = kendoEditor.getRange();
            if ((command === "insertUnorderedList" || command === "insertOrderedList") && range?.collapsed) {
                const $p = $(range.startContainer).closest("p");
                
                // Only intercept if we are in a paragraph with <br> breaks
                if ($p.length > 0 && $p.find("br").length > 0) {
                    const markerId = `m-${Date.now()}`;
                    originalExec.call(kendoEditor, "insertHtml", { html: `<span id="${markerId}"></span>` });

                    const parts = $p.html().split(/<br\s*\/?>/gi);
                    const idx = parts.findIndex(p => p.includes(markerId));
                    
                    if (idx !== -1) {
                        const wrap = (lines: string[]) => lines.length > 0 && lines.some(l => l.trim().length > 0) ? `<p>${lines.join("<br />")}</p>` : "";
                        
                        // Rebuild DOM: Preceding lines | Targeted line | Succeeding lines
                        $p.replaceWith(wrap(parts.slice(0, idx)) + `<p>${parts[idx]}</p>` + wrap(parts.slice(idx + 1)));

                        const $m = $(kendoEditor.body).find(`#${markerId}`);
                        if ($m.length) {
                            const r = kendoEditor.createRange();
                            r.selectNode($m[0]);
                            r.collapse(true);
                            kendoEditor.selectRange(r);
                            $m.remove();
                        }
                    }
                }
            }
            const result = originalExec.call(kendoEditor, command, options);
            EditorToolFunctions.scrollCaretIntoView(kendoEditor);
            return result;
        };

        // 2. Handle Enter vs Shift+Enter specifically for list context
        $(kendoEditor.body).on("keydown", (e) => {
            if (e.keyCode === kendo.keys.ENTER) {
                const $li = $(kendoEditor.getRange()?.startContainer).closest("li");
                if ($li.length > 0) {
                    // In lists: Enter = new item, Shift+Enter = break
                    kendoEditor.exec(e.shiftKey ? "insertLineBreak" : "insertParagraph", {});
                    e.preventDefault();
                    e.stopPropagation();
                }
            }
        });

        // add class to hide toolbar
        const toolbar = $(kendoEditor.toolbar.element).closest(".k-window.k-window-titleless");
        toolbar.addClass("hideToolbarWindow");
        (kendoEditor.toolbar as any).show();
        $(kendoEditor.body).addClass("k-state-active").off("focusout.kendoEditor");
        if ((kendoEditor.toolbar as any)) {
            const toolbarElement = $(kendoEditor.toolbar.element);
            const toolbarWindow = $(toolbarElement).closest(".k-window");
            $(wrapperId).wrapAll('<div class="kendo-text-editor-wrapper"></div>');
            const wrapper = $(wrapperId).closest(".kendo-text-editor-wrapper");
            wrapper.prepend(toolbarElement);
            toolbarWindow.detach();
        }
        //disable floating style -> kendo will set height to 100% and restore it on those events usualy
        const mouseover = (kendoEditor as any)._handlers.find((r) => r.type === "mouseover.kendoEditor");
        const dragenter = (kendoEditor as any)._handlers.find((r) => r.type === "dragenter.kendoEditor");
        const mouseout = (kendoEditor as any)._handlers.find((r) => r.type === "mouseout.kendoEditor");
        const dragleave = (kendoEditor as any)._handlers.find((r) => r.type === "dragleave.kendoEditor");
        if (mouseover) {
            mouseover.element.off(mouseover.type, mouseover.handler);
        }
        if (dragenter) {
            dragenter.element.off(dragenter.type, dragenter.handler);
        }
        if (mouseout) {
            mouseout.element.off(mouseout.type, mouseout.handler);
        }
        if (dragleave) {
            dragleave.element.off(dragleave.type, dragleave.handler);
        }
    }

    // Kendo swallows Enter (preventDefault + exec) and inserts the line break itself, so the
    // browser never scrolls the caret along the way it does while typing.
    private static scrollCaretIntoView(kendoEditor: kendo.ui.Editor) {
        const scroller = <HTMLElement>(<any>kendoEditor).body;
        if (!scroller || scroller.scrollHeight <= scroller.clientHeight) {
            return;
        }

        const caret = EditorToolFunctions.getCaretRect(kendoEditor, scroller);
        if (!caret) {
            return;
        }

        const scrollerRect = scroller.getBoundingClientRect();
        const viewTop = scrollerRect.top + scroller.clientTop;
        const viewBottom = viewTop + scroller.clientHeight;

        if (caret.bottom > viewBottom) {
            scroller.scrollTop += caret.bottom - viewBottom;
        } else if (caret.top < viewTop) {
            scroller.scrollTop -= viewTop - caret.top;
        }
    }

    private static getCaretRect(kendoEditor: kendo.ui.Editor, scroller: HTMLElement): DOMRect {
        const range = kendoEditor.getRange();
        // getRange() reads the document selection, which may belong to another editor.
        if (!range || !scroller.contains(range.startContainer)) {
            return null;
        }

        const caretRect = range.getBoundingClientRect();
        if (caretRect.height > 0) {
            return caretRect;
        }

        // A caret on an element boundary - right behind the <br> Kendo just inserted - has no
        // rectangle of its own. Measure the node next to it, which sits on the caret's line.
        const probe = EditorToolFunctions.createProbeRange(range);
        if (!probe) {
            return null;
        }

        // Take the first line only; a multi-line node would span all of its lines at once.
        const probeRect = probe.getClientRects()[0] || probe.getBoundingClientRect();
        return probeRect.height > 0 ? probeRect : null;
    }

    private static createProbeRange(range: Range): Range {
        let node: Node = range.startContainer;
        let offset = range.startOffset;

        if (node.nodeType === Node.ELEMENT_NODE) {
            const following = node.childNodes[offset];
            if (following) {
                // The node after the caret sits on the caret's own line.
                node = following;
                offset = 0;
            } else if (node.childNodes.length > 0) {
                // Caret behind the last child: that child belongs to the line above, measuring it
                // would scroll one line short. An element without children - a freshly inserted
                // <li> - on the other hand is the caret's line itself and is measured below.
                return null;
            }
        }

        const probe = range.cloneRange();
        if (node.nodeType === Node.TEXT_NODE && node.textContent.length > 0) {
            // Widen over a single character - a whole text node may wrap across several lines.
            const start = Math.min(offset, node.textContent.length - 1);
            probe.setStart(node, start);
            probe.setEnd(node, start + 1);
        } else {
            probe.selectNode(node);
        }

        return probe;
    }

    static postInlieEditorOnSubmit(editorId: string) {
        $("form").on("submit",
            (event) => {
                const form = $(event.target);
                const editorElement = form.find(`#${editorId}`);
                EditorToolFunctions.createInputForEditor(editorElement, form, true);
            });
    }

    static postInlieEditorNotEncodedOnSubmit(editorId: string) {
        $("form").on("submit", (event) => {
            const form = $(event.target);
            const editorElement = form.find(`#${editorId}`);
            EditorToolFunctions.createInputForEditor(editorElement, form, false);
        });
    }

    static createInputForEditor(editorElement: JQuery<Element>, form: JQuery<Element>, encoded: boolean) {
        if (editorElement && editorElement.length > 0) {
            const editor = editorElement.data("kendoOrphyEditor") || editorElement.data("kendoEditor");
            const value: any = encoded ? editor.encodedValue() : editor.value();
            form.find($(`input[name='${editor.element.attr("name")}']`)).remove();
            $("<input type='hidden' />").attr("name", editor.element.attr("name")).val(value).insertAfter(editorElement);
        }
    }
}
